import { ref, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export function useUrlPagination(defaultRowsPerPage = 50) {
  const route = useRoute();
  const router = useRouter();

  const initialPage = parseInt(route.query.page, 10) || 1;

  const serverOptions = ref({
    page: initialPage,
    rowsPerPage: defaultRowsPerPage,
  });

  const updateUrlPage = (page) => {
    const query = { ...route.query };
    if (page > 1) {
      query.page = String(page);
    } else {
      delete query.page;
    }
    router.replace({ query });
  };

  watch(
    () => serverOptions.value.page,
    (newPage) => {
      updateUrlPage(newPage);
    }
  );

  return { serverOptions };
}
